import React from 'react';
import classes from './CommonCheckBox.scss';

const commonCheckBox = (props) => {
    return <label className={`${classes.Label} u-flex`} onClick={props.type === "ssr" ? (e) => e.preventDefault() : null}>
        <input
            {...props}
            type="checkbox" 
            style={{marginTop: '3.5px'}}
            className={classes.CheckInput} />
        <span style={{borderRadius: props.checkboxtype === "square" ? '4px' : '50%'}} className={classes.Checkmark}></span>
    </label>
};

export default commonCheckBox;


// WEBPACK FOOTER //
// ./src/components/UI/CommonCheckBox/CommonCheckBox.js